import React from 'react';
import { replaceThumbnails } from '../thumbnail';
import Colors from './Colors';

class TableTr extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    isKeyInObject(articles, key) {
        let names = [];
        articles.map((v) => {
            let indexs = v.science_index.split(';');
            indexs.map((v2, i) => {
                if (i < 5) {
                    names.push(v2);
                }
            });
        });

        names = names.filter((v) => v != '');
        return names;
    }

    keywordsHandle(articles) {
        let keywordsArry = [];

        articles.map((v) => {
            v.keywords.map((v2, i) => {
                if (i < 5) {
                    keywordsArry.push(v2);
                }
            });
        });

        let set = new Set(keywordsArry);
        let keywords = [...set];

        return keywords
    }

    keywordsRender(articles) {
        let keywords = this.keywordsHandle(articles);
        keywords = keywords.filter(v => v !== '');
        return Colors({ list: keywords, type: 'Keywords' });
    }

    replaceImg = (targetData, e) => {
        e.persist();
        e.target.src = replaceThumbnails[targetData.domain]
    }

    render() {
        let tds = [];
        let data = this.props.trData;
        let isExist = this.props.selectedKeyword.findIndex(v => {
            return v.id == data.idx
        }) !== -1 ? true : false;

        this.props.titles.map((r, k) => {
            let nameValue = 'Name';
            let scienceValue = 'Science_Index';
            let article = data.articles;
            let img = data.img;
            const scienceIndex = this.isKeyInObject(article, scienceValue);

            let row;
            if (r === 'Keywords') {
                row = this.keywordsRender(article);
            } else {
                if (r == 'Image' && img) {
                    row = <img className="list-img" src={img} onError={e => this.replaceImg(data, e)} />
                } else if (r === nameValue) {
                    row = (
                        <div className="name-wrap">
                            <p className="common-name">{data.cname}</p>
                            <p className="scientific-name">
                                {data.sname}
                                <span>({data.domain})</span>
                            </p>
                        </div>
                    );
                } else if (r === 'Science Index') {
                    row = scienceIndex.map((v) => <span>{v}</span>);
                } else if (r === "") {
                    if (data.sname.indexOf(" ") > -1) {
                        data.sname.replace(' ', '-')
                    }
                    row = <a className="detail-keyword white" href={"https://lib.mimic.us/taxon/search?=" + data.sname} target="_blank">i</a>
                }
                else {
                    row = <span>{this.props.trData[r]}</span>;
                }
            }

            tds.push(
                <td key={k} onClick={(e) => this.props.toggleKeyword(e, data, this.keywordsHandle(data.articles), scienceIndex)}>
                    {row}
                </td>
            );
        });

        return <tr className={isExist ? 'active' : ''}>{tds}</tr>;
    }
}

export default TableTr;
